import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class SpacerBlock extends BaseExtension {
  get schema(): NodeSpec {
    return {
      group: 'block',
      isAtom: true,
      parseDOM: [{ tag: 'div.lygo-spacer' }],
      toDOM: () => ['div', { class: 'h-48 mt-12 lygo-spacer' }],
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
